import React from "react";
import { Form } from "react-final-form";
import EmailField from "./EmailField";
import PasswordField from "./PasswordField";
import RememberMeField from "./RememberMeField";
import LoginSubmitButton from "./LoginSubmitButton";
import RegisterLink from "./RegisterLink";

type LoginFormProps = {
    onSubmit: (values: { username: string; password: string; rememberMe?: boolean }) => Promise<unknown>;
    closeLogin: () => void;
    onOpenProfileChoice: () => void;
};

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, closeLogin, onOpenProfileChoice }) => (
    <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting, submitError }) => (
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                {submitError && (
                    <div role="alert" className="rounded-2xl bg-red-50 px-4 py-3 text-sm text-red-600">{submitError}</div>
                )}
                <EmailField />
                <PasswordField />
                <RememberMeField onForgotPassword={closeLogin} />
                <LoginSubmitButton submitting={submitting} />
                <RegisterLink onOpenProfileChoice={onOpenProfileChoice} />
            </form>
        )}
    />
);

export default LoginForm;
